import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";

export function UsersClientActionsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.usersClientActions.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
